import { render, staticRenderFns } from "./RecyclePopup.vue?vue&type=template&id=e1fefad6"
import script from "./RecyclePopup.vue?vue&type=script&lang=js"
export * from "./RecyclePopup.vue?vue&type=script&lang=js"
import style0 from "./RecyclePopup.vue?vue&type=style&index=0&id=e1fefad6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports